const r = { background: "var(--bg-status-primary)" }, a = { background: "var(--common-tertiary)" };
export {
  r as DEFAULT_RIPPLE_SETTING,
  a as PLAIN_RIPPLE_SETTING
};
//# sourceMappingURL=ripple.js.map
